import React, { useEffect, useRef, useState } from "react";
import { useInView, motion, useMotionValue, useTransform, animate } from "framer-motion";

export default function AnimatedCounter({ value, suffix = "", duration = 2, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const count = useMotionValue(0);
  const rounded = useTransform(count, latest => Math.floor(latest).toLocaleString("en-IN"));
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(count, Number(value) || 0, { duration, ease: "easeOut" });
    const unsub = rounded.on("change", v => setDisplay(v));
    return () => { controls.stop(); unsub(); };
  }, [inView, value, duration, count, rounded]);

  return (
    <motion.span ref={ref} className={className}>
      {display}{suffix}
    </motion.span>
  );
}
